import { createElementBlock as t, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function l(c, e) {
  return o(), t("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M9.5 3.5c.3-.3.8-.3 1.1 0s.3.8 0 1.1L5.3 9.8h12.2c.4 0 .8.3.8.8 0 .4-.3.8-.8.8H5.3l5.2 5.2c.3.3.3.8 0 1.1s-.8.3-1.1 0L3 11c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5z"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
